import $ from 'jquery';

const STORAGE_KEY = 'AVX_userswitch';
class Switcher {
	constructor () {
		this.$el = $( '.home .switcher' );
		this.init();
	}

	init () {
		if ( this.$el.length ) {
			if ( ! window.localStorage.getItem( STORAGE_KEY ) ) {
				this.$el.fadeIn();
				document.body.style.overflow = 'hidden';

				this.$el.find( 'a' ).on( 'click', e => this.handle( e ) );
			}
		}
	}

	handle ( e ) {
		let href =  e.target.getAttribute( 'href' );

		if ( href == '#' ) {
			e.preventDefault();
			this.$el.fadeOut();

			document.body.style.overflow = 'auto';
		}

		window.localStorage.setItem( STORAGE_KEY, href );
	}
}

$( document ).ready( () => {
	new Switcher();
} );
